import { jsx as _jsx } from "react/jsx-runtime";
import { DataGrid } from '@mui/x-data-grid';
export const PrimaryGrid = ({ rows, columns, h = 400 }) => {
    const nonSortableColumns = columns.map((column) => ({
        ...column,
        sortable: false
    }));
    return (_jsx("div", { style: {
            height: h,
            width: '100%',
            background: 'white',
            padding: '0px 10px',
            borderRadius: '0px 0px 25px 25px'
        }, children: _jsx(DataGrid, { rows: rows, columns: nonSortableColumns, disableColumnSelector: true, disableRowSelectionOnClick: true, hideFooterPagination: true, disableColumnMenu: true, hideFooterSelectedRowCount: true, hideFooter: true, sx: {
                '& .MuiDataGrid-row': {
                    borderRadius: '5px !important',
                    background: 'red'
                },
                '& .MuiDataGrid-cell:focus': {
                    outline: 'none'
                },
                '& .MuiDataGrid-cell:focus-within': {
                    outline: 'none'
                },
                '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                    height: '5px',
                    width: '5px'
                }
            } }) }));
};
